import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import hitakrilogo from "../../assets/img/hitakrilogo.png";
import logo from "../../assets/img/logo.png";
import buildingImage from "../../assets/img/clinic/4.png";
import "./Navbar.css";

const Navbar = ({ className }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [aboutDropdownOpen, setAboutDropdownOpen] = useState(false);
      const [moreDropdownOpen, setMoreDropdownOpen] = useState(false);
    const [specialitiesDropdownOpen, setSpecialitiesDropdownOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
            if (window.innerWidth > 768) {
                setSidebarOpen(false); // Close sidebar when switching to desktop view
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    useEffect(() => {
        if (isMobile && sidebarOpen) {
            document.body.style.touchAction = 'pan-y'; // Allow vertical scrolling
            document.body.style.overflow = 'hidden'; // Prevent horizontal scroll

        } else {
            document.body.style.touchAction = ''; // Reset to default
            document.body.style.overflow = '';

        }
        return () => {
            document.body.style.touchAction = ''; // Clean-up on unmount
            document.body.style.overflow = '';


        }
    }, [isMobile, sidebarOpen]);


    const toggleAboutDropdown = (e) => {
        if (!isMobile) {
            e.preventDefault();
            setAboutDropdownOpen(!aboutDropdownOpen);
            setSpecialitiesDropdownOpen(false);
        }
    };
    const togglemoreDropdown = (e) => {
        if (!isMobile) {
            e.preventDefault();
            setMoreDropdownOpen(!moreDropdownOpen);
            setSpecialitiesDropdownOpen(false);
        }
    };

    const toggleSpecialitiesDropdown = (e) => {
        if (!isMobile) {
            e.preventDefault();
            setSpecialitiesDropdownOpen(!specialitiesDropdownOpen);
            setAboutDropdownOpen(false);
        }
    };

    const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
    const [mobileSpecialitiesOpen, setMobileSpecialitiesOpen] = useState(false);

    const toggleMobileAbout = () => {
        setMobileAboutOpen(!mobileAboutOpen);
        setMobileSpecialitiesOpen(false);  //Close the other one
    };

    const toggleMobileSpecialities = () => {
        setMobileSpecialitiesOpen(!mobileSpecialitiesOpen);
        setMobileAboutOpen(false); //Close the other one
    };

    const goBack = () => {
        if (mobileAboutOpen || mobileSpecialitiesOpen) {
            if (mobileAboutOpen) {
                setMobileAboutOpen(false);
            } else {
                setMobileSpecialitiesOpen(false);
            }

        }
    };


    return (
        <>
            <nav className={`your-navbar-base-class ${className || ''}`}>
            {/* Top Header Bar */}
            <div className="header-bar">
                <div className="emergency-section">
                    <i className="icon-ambulance">🚑</i>
                    <span>Emergency Services: <strong>+91-9462145151</strong></span>
                </div>
                <div className="nav-links">
                    {/* <a href="/about">📝 Health Checkup Plans</a> */}
                    <span>|</span>
                    <a href="/contact">✉️ Quick Enquiry</a>
                </div>
                <div className="nav-links-social">
                    <a href="https://www.facebook.com/p/Hitkari-Hospital-1000639316666732/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                    <span>|</span>
                    <a href="https://www.instagram.com/hitkarihospital/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-instagram"></i>
                    </a>
                     <span>|</span>
                     <a href="https://in.linkedin.com/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-linkedin"></i>
                    </a>
                </div>
            </div>

            {/* Navbar */}
            <nav className="navbar header-nav">
                <div className="navbar-header">
                    {isMobile && (
                        <button onClick={toggleSidebar} className="bar-icon">
                            <span className={`bar ${sidebarOpen ? 'open' : ''}`}></span>
                            <span className={`bar ${sidebarOpen ? 'open' : ''}`}></span>
                            <span className={`bar ${sidebarOpen ? 'open' : ''}`}></span>
                        </button>
                    )}
                    <a href="/" className="navbar-brand logo">
                        <img src={hitakrilogo} className="img-fluid" alt="Hitkari Hospital Logo" />
                    </a>
                </div>

                {!isMobile && (
                    <ul className="main-nav" >
                        <li ><Link to="/" style={{fontWeight:"bold"}}>Home</Link></li>
                        <li className={`dropdown ${aboutDropdownOpen ? "active" : ""}`}>
                            <a href="/about" onClick={toggleAboutDropdown} style={{fontWeight:"bold"}}>About Us <i class="fas fa-chevron-down" style={{marginLeft:"10px"}}></i></a>
                            <div className={`dropdown-content ${aboutDropdownOpen ? "active" : ""}`}>
                                <ul>
                                    <li><Link to="/about"  style={{fontWeight:"bold"}}>About Us</Link></li>
                                    <li><Link to="/leadership"  style={{fontWeight:"bold"}}>Leadership</Link></li>
                                </ul>
                            </div>
                        </li>
                        <li className={`dropdown ${specialitiesDropdownOpen ? "active" : ""}`}>
                            <a href="/specialities" onClick={toggleSpecialitiesDropdown} style={{fontWeight:"bold"}}>Specialities<i class="fas fa-chevron-down" style={{marginLeft:"10px"}}></i></a>
                            <div className={`dropdown-content specialities-dropdown ${specialitiesDropdownOpen ? "active" : ""}`}>
                                <div className="specialities-content">
                                    <div className="specialities-image">
                                        <img src={buildingImage} alt="Specialities" />
                                    </div>
                                    <div className="specialities-list">
                                        <div className="specialities-heading" style={{fontWeight:"bold"}}>Specialities</div>
                                        <ul>
                                            <li><Link to="/urology">Urology</Link></li>
                                           
                                            <li><Link to="/lap">Laparoscopy & GI Surgery</Link></li>
                                            <li><Link to="/icu">ICU and Critical Care</Link></li>
                                            <li><Link to="/women">Women and Child Care</Link></li>
                                            <li><Link to="/onco">Oncology</Link></li>
                                            <li><Link to="/ent">ENT</Link></li>
                                            <li><Link to="/internal">Internal Medicine</Link></li>
                                            <li><Link to="/orthopedic">Orthopedic and Joint Replacement</Link></li>
                                            <li><Link to="/ped">Pediatric</Link></li>
                                            <li><Link to="/emergency">Emergency</Link></li>
                                            <li><Link to="/neurology">Neurology</Link></li>
                                            <li><Link to="/radiology">Radiology</Link></li>
                                            <li><Link to="/pharmacy">Pharmacy</Link></li> 
                                            <li><Link to="/anaesthesia">Anaesthesia</Link></li>
                                            <li><Link to="/OB-GYN">OB-GYN</Link></li>
                                            <li><Link to="/NICU">NICU</Link></li>
                                            <li><Link to="/SICU">SICU</Link></li>

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </li>
                        
                        <li><Link to="/listdoctor" style={{fontWeight:"bold"}}>Specialist</Link></li>
                        <li><Link to="/facilities" style={{fontWeight:"bold"}}>Facilities</Link></li>
                        <li><Link to="/contact" style={{fontWeight:"bold"}}>Contact Us</Link></li>
                         <li className={`dropdown ${moreDropdownOpen ? "active" : ""}`}>
                            <a href="/about" onClick={togglemoreDropdown} style={{fontWeight:"bold"}}>More<i class="fas fa-chevron-down" style={{marginLeft:"10px"}}></i></a>
                            <div className={`dropdown-content ${moreDropdownOpen ? "active" : ""}`}>
                                <ul>
                                    <li><Link to="/gallery"  style={{fontWeight:"bold"}}>Gallery</Link></li>
                                    <li><Link to="/blogs"  style={{fontWeight:"bold"}}>Blog</Link></li>
                                    <li><Link to="/videogallery"  style={{fontWeight:"bold"}}>Video Gallery</Link></li>
  <li><Link to="/carrer"  style={{fontWeight:"bold"}}>carrer</Link></li>
                                </ul>
                            </div>
                        </li>
                         <li><Link  to="/patientlogin" style={{fontWeight:"bold",}}>Patient Login</Link></li>
                    </ul>
                )}

                <ul className="nav header-navbar-rht">
                    <li className="nav-item">
                        <a className="nav-link header-login" href="/appointments">Book Appointment</a>
                    </li>
                   
                </ul>
            </nav>

            {/* Sidebar (Mobile Only) */}
            {isMobile && sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

            {isMobile && (
                <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
                    <button className="close-btn" onClick={toggleSidebar}>×</button>
                    <a href="/" className="menu-logo">
                        <img src={logo} className="img-fluid" alt="Hitkari Hospital Logo" />
                    </a>
                    <ul className="sidebar-menu" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 150px)' }}>
                        <li><Link to="/" onClick={toggleSidebar}>Home</Link><div className="white-line"></div></li>
                        {mobileAboutOpen || mobileSpecialitiesOpen ? (
                            <li className="mobile-dropdown-list">
                                <button className="mobile-dropdown-button" onClick={goBack}>
                                    <i className="fas fa-chevron-left"></i>
                                    {mobileAboutOpen ? "About Us" : "Specialities"}
                                </button>
                                <div className="white-line"></div>
                            </li>
                        ) : null}

                        {mobileAboutOpen ? (
                            <>
                                <li className="mobile-dropdown-list">
                                    <Link to="/about" onClick={toggleSidebar}>
                                        <i className="fas fa-info-circle"></i> About Us
                                    </Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/leadership" onClick={toggleSidebar}>
                                        <i className="fas fa-users"></i> Leadership
                                    </Link>
                                    <div className="white-line"></div>
                                </li>
                            </>
                        ) : mobileSpecialitiesOpen ? (
                            <>
                                <li className="mobile-dropdown-list">
                                    <Link to="/urology" onClick={toggleSidebar}>Urology</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/cardiology" onClick={toggleSidebar}>Cardiology</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/hepatology" onClick={toggleSidebar}>Hepatology</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/lap" onClick={toggleSidebar}>Laparoscopy & GI Surgery</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/icu" onClick={toggleSidebar}>ICU and Critical Care</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/women" onClick={toggleSidebar}>Women and Child Care</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/onco" onClick={toggleSidebar}>Oncology</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/ent" onClick={toggleSidebar}>ENT</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/internal" onClick={toggleSidebar}>Internal Medicine</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/orthopedic" onClick={toggleSidebar}>Orthopedic and Joint Replacement</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/ped" onClick={toggleSidebar}>Pediatric</Link>
                                    <div className="white-line"></div>
                                </li>

                                <li className="mobile-dropdown-list">
                                    <Link to="/skin" onClick={toggleSidebar}>Dermatology & Cosmetology</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/emergency" onClick={toggleSidebar}>Emergency</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/dental" onClick={toggleSidebar}>Dental</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/psy" onClick={toggleSidebar}>Psychiatrist</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/phy" onClick={toggleSidebar}>Physiotherapy and Rehabilitation</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <Link to="/neurology" onClick={toggleSidebar}>Neurology</Link>
                                    <div className="white-line"></div>
                                </li>
                            </>
                        ) : (
                            <>
                               <li className="mobile-dropdown-list">
                                    <button className="mobile-dropdown-button" onClick={toggleMobileAbout}>
                                        About Us <i className="fas fa-chevron-right" style={{ marginLeft: '5px' }}></i>
                                    </button>
                                    <div className="white-line"></div>
                                </li>
                                <li className="mobile-dropdown-list">
                                    <button className="mobile-dropdown-button" onClick={toggleMobileSpecialities}>
                                        Specialities <i className="fas fa-chevron-right" style={{ marginLeft: '5px' }}></i>
                                    </button>
                                    <div className="white-line"></div>
                                </li>
                                <li><Link to="/listdoctor" onClick={toggleSidebar}>Specialist</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li><Link to="/facilities" onClick={toggleSidebar}>Facilities</Link>
                                    <div className="white-line"></div>
                                </li>
                                 <li><Link to="/gallery" onClick={toggleSidebar}>Gallery</Link>
                                    <div className="white-line"></div>
                                </li>
                                 <li><Link to="/videogallery" onClick={toggleSidebar}>Video Gallery</Link>
                                    <div className="white-line"></div>
                                </li>
                                   <li><Link to="/blogs" onClick={toggleSidebar}>Blog</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li><Link to="/contact" onClick={toggleSidebar}>Contact Us</Link>
                                    <div className="white-line"></div>
                                </li>
                                <li><Link to="/carrer"  onClick={toggleSidebar}>carrer</Link> <div className="white-line"></div></li>
                                 <li><Link  to="/patientlogin" style={{fontWeight:"bold",}}>Patient Login</Link></li>
                            </>
                        )}
                    </ul>
                </div>
            )}
            </nav>
        </>
    );
};

export default Navbar;